// a little function to help us with reordering the result
export const Reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 6;
export const getItemStyle = (isDragging, draggableStyle) => {
  return {
    ...draggableStyle,

    cursor: isDragging ? "all-scroll" : "pointer",
  };
};

export const getQuestionListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "lightblue" : "lightgrey",
  padding: 8,
  width: 350,
});

export const getAnswerListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "lightblue" : "lightgrey",
  padding: 4,
  width: 250,
});

export const handleDownload = async (file_link) => {
  try {
    const anchor = document.createElement("a");
    anchor.href = file_link;
    anchor.download = "document";
    anchor.click();
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};
